import { FieldValues } from 'react-hook-form';

export const isCampaignVacationDaysAllocation = (fieldValues: FieldValues) =>
  fieldValues.type === 'unused_vacation_days' && fieldValues.choice_collected_by === 'distributor';
